import type { ThirdPartyProvidersFeature } from '../types';

export const thirdPartyProviders: ThirdPartyProvidersFeature = {
    enabled: true,
    _description:
        'Third Party Providers option accessible from User Settings. Redirects to local bank system to manage third-party access to information about the user and their products/services.',
    alternateHandover: {
        enabled: true,
        _description:
            'Opens Administration of the third parties by using a new URL and targetClientId',
    },
};
